import { memo, useState } from 'react'
import { Wallet } from 'lucide-react'
import { usePmWalletStore } from '@/store/pmWalletStore'
import { Button } from '@/components/ui/button'
import { WalletDialog } from './WalletDialog'

export const WalletButton = memo(function WalletButton() {
  const pmAddress = usePmWalletStore((s) => s.pmAddress)
  const activeWallet = usePmWalletStore((s) => s.activeWallet)
  const encryptedData = usePmWalletStore((s) => s.encryptedData)
  const [walletOpen, setWalletOpen] = useState(false)

  const needsUnlock = activeWallet === 'pm' && encryptedData !== null && pmAddress === null
  const isPmConnected = activeWallet === 'pm' && pmAddress !== null
  const isConnected = isPmConnected || needsUnlock

  return (
    <>
      {isConnected ? (
        <Button
          variant="secondary"
          size="icon"
          className="rounded-full"
          onClick={() => setWalletOpen(true)}
        >
          <Wallet className="h-5 w-5" />
        </Button>
      ) : (
        <Button
          variant="default"
          size="sm"
          className="rounded-full font-semibold"
          onClick={() => setWalletOpen(true)}
        >
          Connect
        </Button>
      )}
      <WalletDialog open={walletOpen} onClose={() => setWalletOpen(false)} />
    </>
  )
})
